/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

const ADD_POINT = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value.points.push(payload.feature)
}

const REMOVE_POINT = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.page]
        .components[payload.component]
        .value.points.splice(payload.index, 1)
}

const FOCUS_POINT = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.page]
        .components[payload.component]
        .value.center = payload.locale
}

const ADD_TEXT = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value.body = payload.value
}

const DELETE_TEXT = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value.body = payload
}

const UPDATE_TABLE_HEADER = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value
        .headers.splice(payload.cell, 1, payload.value)
}

const UPDATE_TABLE_DATA = (state, payload) => {
    var cell = state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value
        .rows[payload.row]
        .values[payload.cell]
    cell['data'] = payload.value
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value
        .rows[payload.row]
        .values.splice(payload.cell, 1, cell)
}

const ADD_TABLE_ROW = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.page]
        .components[payload.component]
        .value.rows.push(payload.value)
}

const ADD_TABLE_COLUMN = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.page]
        .components[payload.component]
        .value.headers.push(payload.header)

    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.page]
        .components[payload.component]
        .value.rows.map(row => {
            row.values.push(JSON.parse(JSON.stringify(payload.column)))
        })
}

const REMOVE_TABLE_ROW = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value.rows.splice(payload.rowNumber, 1)
}

const REMOVE_TABLE_COLUMN = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value.headers.splice(payload.columnNumber, 1)

    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]
        .value.rows.forEach(row => {
            row.values.splice(payload.columnNumber, 1)
        })
}

const UPDATE_PAGE = (state, payload) => {
    var page = state
                   .digitalOM
                   .sections[payload.sectionIndex]
                   .data[payload.pageIndex]
    page['title'] = payload.title
    page['layout'] = payload.layout
    page['id'] = payload.id

    state.digitalOM.sections[payload.sectionIndex].data.splice(payload.pageIndex, 1, page)
}

const UPDATE_PAGE_TITLE = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex].title = payload.value
}

const UPDATE_SECTION_TITLE = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .title = payload.value
}

const CREATE_NEW_SECTION = (state, payload) => {
    state
        .digitalOM
        .sections.push({
            title: payload.title,
            data: payload.data,
            visible: payload.visible
        })
}

const CREATE_NEW_PAGE = (state, payload) => {
    state.digitalOM.sections[payload.sectionIndex].data.push({
        id: payload.pageId,
        title: payload.title || null,
        layout: payload.layout.name,
        data: [],
        order: null,
        components: new Array(payload.layout.components)
            .fill({})
            .map(item => {
                item.type = null
                item.value = null
                return item
            })
    })
}

const CREATE_NEW_COMPONENT = (state, payload) => {
    state.digitalOM.sections[payload.sectionIndex].data[payload.page].components[payload.position] = {
        type: payload.type,
        position: payload.position,
        value: payload.value
    }
}

const UPDATE_COMPONENT = (state, payload) => {
    var component = state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]

    component['id'] = payload.componentId

    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components.splice(payload.componentIndex, 1, component)
}

const SETUP_DIGITAL_OM = (state, payload) => {
    state.digitalOM['id'] = payload.id
    state.digitalOM['address'] = payload.address
}

const GET_SECTIONS = (state, payload) => {
    const arr = []
    payload.forEach(section => {
        const obj = {}
        obj['title'] = section.title
        obj['id'] = section.id
        obj['visible'] = section.is_visible
        obj['data'] = []
        arr.push(obj)
    })
    state.digitalOM.sections = arr
}

const GET_PAGES = (state, payload) => {
    var pages = state.digitalOM.sections[payload.sectionIndex]
    pages['data'] = payload.data
    state.digitalOM.sections.splice(payload.sectionIndex, 1, pages)
}

const UPDATE_SECTION_ID = (state, payload) => {
    var section = state.digitalOM.sections[payload.index]
    section['id'] = payload.sectionId
    state.digitalOM.sections.splice(payload.index, 1, section)
}

const SET_PAGE_COMPONENT = (state, payload) => {
    let target = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components
    target.splice(payload.componentIndex, 1,
        JSON.parse(JSON.stringify(state.defaults[payload.componentType])))
}

const GET_COMPONENTS = (state, payload) => {
    var page = JSON.parse(JSON.stringify(state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex]))
    page['data'] = payload.data
    console.log(page)
    let layout = state.layouts.find(layout => {
        return layout.name === page['layout']
    })
    page['components'] = new Array(layout.components)
        .fill({})
        .map(item => {
            item.type = null
            item.value = null
            return item
        })
    payload.data.forEach(component => {
        page['components'][component.position] = {
            type: component.type,
            value: component.value,
            id: component.id
        }
    })
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data.splice(payload.pageIndex, 1, page)
}

const TOGGLE_PANEL = state => {
    state.showPanel = !state.showPanel
}

const REMOVE_COMPONENT = (state, payload) => {
    let target = state.digitalOM.sections[payload.sectionIndex].data[payload.pageIndex].components
    target.splice(payload.componentIndex, 1, {
        type: null,
        value: null
    })
}

const REMOVE_PAGE = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data.splice(payload.pageIndex, 1)
}

const REMOVE_SECTION = (state, sectionIndex) => {
    state
        .digitalOM
        .sections.splice(sectionIndex, 1)
}

const LOAD_IMAGE = (state, payload) => {
    var component = state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex]

    component.value['source'] = payload.value

    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components.splice(payload.componentIndex, 1, component)
}

const IMAGE_UPLOAD_SUCCESS = (state, payload) => {
    state
        .digitalOM
        .sections[payload.sectionIndex]
        .data[payload.pageIndex]
        .components[payload.componentIndex].value = {
            image_id: payload.data.image_id,
            source: payload.data.image.url
        }
    console.log('success')
}

const IMAGE_UPLOAD_FAILURE = (state, payload) => {
}

const REORDER_PAGES = (state, payload) => {
    state
        .digitalOM
        .sections[0]
        .data = payload
}

const NEST_PAGE = (state, payload) => {
    state
        .digitalOM
        .sections[0]
        .data[payload.page]
        .pages = payload.nest
}

const TOGGLE_MENU = state => {
    state.showMenu = !state.showMenu
}

const SET_DIGITAL_OM_META = (state, payload) => {
    state.meta = payload
}

const SET_WAR_ROOM_ID = (state, id) => {
    state.warRoomId = id
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

const SET_LAYOUT_SECTION = (state, payload) => {
    if (payload) {
        state.pageSelection.sectionIndex = payload.sectionIndex
        state.pageSelection.sectionId = payload.sectionId
        state.pageSelection.pageIndex = payload.pageIndex
    } else {
        state.pageSelection.sectionIndex = null
        state.pageSelection.sectionId = null
        state.pageSelection.pageIndex = null
    }
}

const OPEN_LAYOUT_MODAL = state => {
    state.pageSelection.showModal = true
}

const CLOSE_LAYOUT_MODAL = state => {
    state.pageSelection.showModal = false
    state.pageSelection.sectionIndex = null
    state.pageSelection.sectionId = null
    state.pageSelection.pageIndex = null
}

const TOGGLE_EDIT_MODE = (state, value) => {
    state.isEditing = !state.isEditing
}

export default {
    RESET_STATE,
    REMOVE_PAGE,
    REMOVE_SECTION,
    ADD_POINT,
    REMOVE_POINT,
    FOCUS_POINT,
    REMOVE_COMPONENT,
    UPDATE_PAGE,
    UPDATE_PAGE_TITLE,
    UPDATE_SECTION_TITLE,
    ADD_TEXT,
    DELETE_TEXT,
    TOGGLE_PANEL,
    SET_PAGE_COMPONENT,
    UPDATE_TABLE_DATA,
    UPDATE_TABLE_HEADER,
    ADD_TABLE_ROW,
    ADD_TABLE_COLUMN,
    REMOVE_TABLE_ROW,
    REMOVE_TABLE_COLUMN,
    CREATE_NEW_PAGE,
    CREATE_NEW_COMPONENT,
    CREATE_NEW_SECTION,
    UPDATE_SECTION_ID,
    SETUP_DIGITAL_OM,
    GET_SECTIONS,
    GET_PAGES,
    GET_COMPONENTS,
    LOAD_IMAGE,
    IMAGE_UPLOAD_SUCCESS,
    IMAGE_UPLOAD_FAILURE,
    UPDATE_COMPONENT,
    REORDER_PAGES,
    NEST_PAGE,
    TOGGLE_MENU,
    SET_DIGITAL_OM_META,
    SET_WAR_ROOM_ID,
    SET_LAYOUT_SECTION,
    OPEN_LAYOUT_MODAL,
    CLOSE_LAYOUT_MODAL,
    TOGGLE_EDIT_MODE
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/mutations.js